import ToggleRight from '@components/Icons/ToggleRight';
import * as ApiModels from '@typings/api-models';
import BaseAnswer from './BaseAnswer';
import s from '../QuestionAndAnswer.module.scss';

type Props = {
  field: ApiModels.FormResponseYesNoField;
};

const YesNoAnswer: React.FC<Props> = ({ field: { answer } }) => (
  <div className={s.answer}><ToggleRight weight='regular' /><BaseAnswer answer={answer ? 'Yes' : 'No'} /></div>
);

export default YesNoAnswer;
